<template>
  <div>
        <ctop />
        <cswiper />
        <search />
        <div class="c_content">
            <div class="crumbs">
                <div class="border"></div>
                <div class="now">当前位置：</div>
                <div class="one">联系我们</div>
            </div>

            <div class="q_content">
                <div class="t_title">
                    <div class="border"></div>
                    <div class="title">公司简绍</div>
                    <div class="border"></div>
                </div>
                <div class="en_title">Company introduction</div>
            </div>

            <div class="img_content">
                <div class="left">
                    <div class="top">
                        <img class="img1" src="~@/assets/gs1.png">
                    </div>
                    <div class="bottom">
                        <img class="img2" src="~@/assets/gs2.png">
                        <img class="img3" src="~@/assets/gs3.png">
                        <img class="img4" src="~@/assets/gs4.png">
                    </div>
                </div>
                <div class="right">
                    <div class="content">
                        <div class="title_top">中一广告策划</div>
                        <div class="fw_text">
                                <p>中山本土专业广告旗帜，成立于2004年1月18日；</p>

                                <p>下设江门分公司、佛山分公司，太阳雨喷画展示、顺威印刷包装厂；</p>

                                <p>中一是立足于品牌策划、公共关系、文艺演出、影视广告产品市场推广服务、地产策划和广告执行的综合广告公司</p>

                                <p>中一拥有专业的策划团队、设计团队、执行落地团队，可为客户提供一站服务；</p>

                                <p>中一业务范围广泛，业务能力可达广东省各城市，可实现跨城服务；</p>

                                <p>中一自始至终强调严谨、创新、诚信、热情的工作态度，以中一人的“七彩人生观”，努力为客户提供系统而专业的服务。</p>
                        </div>
                    </div>
                </div>
            </div>

            


        </div>

        <div class="gy">

           <div class="gy_bg">
                <div class="t_title">
                    <div class="border"></div>
                    <div class="title">感言</div>
                    <div class="border"></div>
                </div>
                <div class="en_title">thoughts expressed in words</div>

                <div class="gy_content">
                    <div class="list">要想做到第一</div>
                    <div class="list">不论要耗费多少经历多少时间</div>
                    <div class="list">只要是对客户所做的承诺就一定要做到!</div>
                </div>

                <div class="ceo">
                    <div class="user_img"></div>
                    <div class="name">董事长</div>
                </div>
           </div>

        </div>


        <div class="contact_us">

           <div class="gy_bg">
                <div class="t_title">
                    <div class="border"></div>
                    <div class="title">联系我们</div>
                    <div class="border"></div>
                </div>
                <div class="en_title">contact us</div>
                
                <baidu-map :center="center" :zoom="zoom" @ready="baiduMapFun" :scroll-wheel-zoom='true' class="baiduMap"></baidu-map>
                
                <div class="option">
                    <img src="~@/assets/option.png">
                </div>
                <div class="explain bziti">
                    <div class="list">24小时热线</div>
                    <div class="list">公司地址</div>
                    <div class="list">公司邮箱</div>
                    <div class="list">公司手机</div>
                </div>
                <div class="explain rziti">
                    <div class="list">0760-88929118</div>
                    <div class="list">中山市兴中道28号中山体育场附近</div>
                    <div class="list">chinaone_zs@126.com</div>
                    <div class="list">18022118773</div>
                </div>
           </div>

        </div>


        <div class="contact_us">

           <div class="gy_bg">
                <div class="t_title">
                    <div class="border"></div>
                    <div class="title">在线留言</div>
                    <div class="border"></div>
                </div>
                <div class="en_title">contact us</div>
                
                <div class="input_content">
                    <div class="left">
                        <div class="name">
                            <span>您的称呼：</span>
                            <el-input v-model="form.name" placeholder="请输入内容"></el-input>
                        </div>
                        <div class="name">
                            <span>联系手机：</span>
                            <el-input v-model="form.phone" placeholder="请输入内容"></el-input>
                        </div>
                        <div class="name">
                            <span>微信号：</span>
                            <el-input v-model="form.wx" placeholder="请输入内容"></el-input>
                        </div>
                        <div class="name">
                            <span>您的邮箱：</span>
                            <el-input v-model="form.email" placeholder="请输入内容"></el-input>
                        </div>
                    </div>
                    <div class="right">
                        <div class="des">
                            <textarea v-model="form.content" placeholder="请输入您的留言，客服人员会第一时间联系您"></textarea>
                        </div>
                    </div>
                </div>

                <div class="addinfo" @click="postcontent()">提交</div>
           </div>

        </div>

        <div class="mar"></div>
        <bottom />
        <right />
  </div>
</template>

<script>
import ctop from '@/components/ctop'
import cswiper from '@/components/cswiper'
import search from '@/components/search'
import bottom from '@/components/bottom'
import BaiduMap from 'vue-baidu-map';
import right from '@/components/right'
export default {
  name: 'Home',
  components: {
      cswiper,
      ctop,
      search,
      bottom,
      right
  },
  data () {
    return {
       currentPage3: 5,
       form:{
           name:'',
           phone:'',
           wx:'',
           email:'',
           content:'',
           id:2
       }
    }
  },
  computed: {
    
  },
  mounted() {
    
  },
  methods:{
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        },
        baiduMapFun({BMap, map}) {
            var point = new BMap.Point(113.394403, 22.513271)
            map.centerAndZoom(point, 17)
            var marker = new BMap.Marker(point) // 创建标注
            map.addOverlay(marker) // 将标注添加到地图中
            var circle = new BMap.Circle(point, 6, {
                strokeColor: 'Red',
                strokeWeight: 6, 
                strokeOpacity: 1, 
                Color: 'Red', 
                fillColor: '#f03' 
            })
            map.addOverlay(circle)
        },
        postcontent(){
            if(this.form.name == ''){
                this.$message({
                    message: '请填写名称',
                    type: 'warning'
                })
                return false
            }
            if(this.form.phone == ''){
                this.$message({
                    message: '请填写联系手机',
                    type: 'warning'
                })
                return false
            }
            if(this.form.wx == ''){
                this.$message({
                    message: '请填写微信号',
                    type: 'warning'
                })
                return false
            }
            if(this.form.email == ''){
                this.$message({
                    message: '请填写您的邮箱',
                    type: 'warning'
                })
                return false
            }
            if(this.form.content == ''){
                this.$message({
                    message: '请填写留言',
                    type: 'warning'
                })
                return false
            }
            this.$http.post('/api/help/opinion',this.$qs.stringify({data:this.form})).then((res)=>{
                let callback = res.data
                if(callback.code == 200){
                    this.$message({
                        message: '提交成功',
                        type: 'success'
                    })
                    this.form = {
                        name:'',
                        phone:'',
                        wx:'',
                        email:'',
                        content:'',
                        id:2
                    }
                }else{
                    this.$message({
                        message: '提交失败',
                        type: 'error'
                    });
                }
            }).catch((error) => {
                console.log('获取失败')
            })
        }
  },
  
}
</script>

<style lang="scss" scoped>
$zycolor:#CF2C2E;

.c_content{
    width: 100%;
    padding:0 75px;
    box-sizing: border-box;
}
.crumbs{
    display: flex;
    border-bottom: 1px solid #eee;
    padding: 15px 0;
    align-items: center;
    .border{
        height: 20px;
        width: 5px;
        background: #CF2C2E;
        border-radius: 5px;
        margin:0 20px 0 65px;
    }
    .fu{
        margin:0 5px;
    }
}
.q_content{
    display: flex;
    justify-content: space-between;
    margin-top:80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .t_title{
        display: flex;
        justify-content: center;
        align-items: center;
        justify-content: center;
    }
    .border{
        width: 230px;
        height: 1px;
        background: #707070;
    }
    .title{
        margin:0 20px;
        font-size: 24px;
    }
    .en_title{
        color: #A1A1A1;
        margin-top:10px;
    }
}
.img_content{
    margin-top:100px;
    display: flex;
    justify-content: space-around;
    .left{
        width: 48%;
        .img1{
            width: 100%;
            height: 478px;
        }
    }
    .bottom{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top:10px;
        .img2 ,.img3,.img4{
            width: 280px;
            height: 279px;
        }
    }
    .right{
        width: 48%;
        .content{
            padding:20px;
        }
        .title_top{
            font-size: 24px;
            color:#222222;
        }
    }
}
.service{
    width: 100%;
    margin-top:40px;
    display: flex;
    flex-direction: column;
    text-align: left;
    border:1px solid #a1a1a1;
    justify-content: center;
    align-items: center;
    .content{
        width: 100%;
        padding:0 10px;
        box-sizing: border-box;
    }
    img{
        width: 100%;
        height: 200px;
    }
    .name{
        font-weight: bold;
        padding:15px 0;
    }
    .list{
        margin-bottom:10px;
        border-top:1px solid #a1a1a1;
        padding:10px 0 0 0;
        display: flex;
        align-items: center;
        span:nth-child(1){
            width: 30%;
        }
        .right{
            width: 70%;
            display: flex;
            flex-direction: column;
        }
    }
    .lianxi{
        width: 240px;
        // height: 50px;
        background: #CF2C2E;
        color: #fff;
        margin:30px 0;
        border-radius: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding:5px 0;
        img{
            width: 30px;
            height: 30px;
        }
    }
}

.mar{
    width: 100%;
    height: 100px;
}

.gy{
    display: flex;
    justify-content: space-between;
    margin-top:80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background: url('~@/assets/gy.png') no-repeat;
    .gy_bg{
        width: 100%;
        height: 100%;
        background: rgba(000, 000, 000,0.7);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom:40px;
    }
    .t_title{
        display: flex;
        justify-content: center;
        align-items: center;
        justify-content: center;
        margin-top:30px;
    }
    .border{
        width: 230px;
        height: 1px;
        background: #fff;
    }
    .title{
        margin:0 20px;
        font-size: 24px;
        color: #fff;
    }
    .en_title{
        color: #fff;
        margin-top:10px;
        margin-bottom:30px;
    }
    .gy_content{
        background: url('~@/assets/gy_content.png') no-repeat center center;
        width: 100%;
        height: 400px;
        margin-top:20px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        color:#fff;
        .list{
            margin:10px 0;
        }
    }
    .ceo{
        .user_img{
            width: 70px;
            height: 70px;
            border-radius: 50%;
            background: #fff;
            margin-top:20px;
        }
        .name{
            margin-top:10px;
            color: #fff;
        }
    }
}

.contact_us{
    padding:0 75px;
    .gy_bg{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom:40px;
    }
    .t_title{
        display: flex;
        justify-content: center;
        align-items: center;
        justify-content: center;
        margin-top:30px;
    }
    .border{
        width: 230px;
        height: 1px;
        background: #222;
    }
    .title{
        margin:0 20px;
        font-size: 24px;
        color: #222;
    }
    .en_title{
        color: #222;
        margin-top:10px;
        margin-bottom:30px;
    }
    .option{
        width: 1250px;
        margin-top:60px;
        img{
            width: 100%;
        }
    }
    .explain{
        width: 1435px;
        display: flex;
        justify-content: space-around;
        margin-top:20px;
        .list{
            width: 25%;
            text-align: center;
        }
    }
    .bziti{
        color: #222;
    }
    .rziti{
        color: #CF2C2E;
    }
}

.baiduMap{
    width: 100%;
    height: 500px;
    padding-top: 30px;
}
.input_content{
    width: 80%;
    display: flex;
    margin:20px 0;
    .left{
        width: 50%;
        .name{
            display: flex;
            align-items: center;
            margin-bottom:40px;
            span{
                width: 200px;
            }
        }
    }
    .right{
        width: 50%;
        padding: 0 60px;
        .des{
            textarea{
                width: 100%;
                height: 275px;
                resize:none;
                border: 1px solid #DCDFE6;
                padding:15px;
                box-sizing: border-box;
            }
        }
    }
}
.addinfo{
    padding:10px 140px;
    background: $zycolor;
    color:#fff;
    border-radius: 40px;
    cursor: pointer;
}
</style>
